import React from "react";
import { FaSignInAlt } from "react-icons/fa";
import {Link} from "react-router-dom";
import AuthLayout from "../../components/Layouts/AuthLayout";
import {RouteNames} from "../../constants";
import EmailVerifiedIcon from "../../assets/icons/email-verified-icon.png";

const EmailVerified = () => {
    return (
        <AuthLayout>
            <div className="login forget-password">
                <div className="flex justify-end">
                    <Link to={RouteNames.LOGIN} className="btn btn-outline">
                        <FaSignInAlt className="mr-2"/>
                        Login
                    </Link>
                </div>
                <div className="password_updated max-w-[500px] mx-auto">
                        <img src={EmailVerifiedIcon} alt=""/>
                        <div className="password_updated_head">
                            Email verified
                        </div>
                        <div className="password_updated_text">
                            Your email has been verified, please log in to complete your account registration process.
                        </div>
                        <div className="flex justify-center mt-10">
                            <Link to={RouteNames.LOGIN} className="btn btn-primary btn-b">
                                Continue
                            </Link>
                        </div>

                    </div>
            </div>
        </AuthLayout>
    )
}

export default EmailVerified;